import { lookupCard } from "../../content/index.js";
import { actionDraw } from "../deck/actionDraw.js";
import type { CardInstanceId, RunState } from "../types/index.js";

function isHandWorker(run: RunState, id: CardInstanceId): boolean {
  const card = run.hand.find((item) => item.instanceId === id);
  return Boolean(card && lookupCard(card.cardId)?.type === "worker");
}

export function toggleStables(run: RunState, id: CardInstanceId): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "stables") return null;
  if (!isHandWorker(run, id)) return null;
  const selected = pending.selected[0] === id ? [] : [id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function resolveStables(run: RunState): { run: RunState; reshuffled: boolean } {
  const pending = run.pendingChoice;
  if (pending?.kind !== "stables") {
    return { run: { ...run, pendingChoice: null }, reshuffled: false };
  }
  const id = pending.selected[0];
  if (!id || !isHandWorker(run, id)) {
    return { run: { ...run, pendingChoice: null }, reshuffled: false };
  }
  const chosen = run.hand.find((card) => card.instanceId === id);
  const hand = run.hand.filter((card) => card.instanceId !== id);
  const drawn = actionDraw(
    { ...run, discard: [...run.discard, ...chosen ? [chosen] : []] },
    3,
  );
  return {
    reshuffled: drawn.reshuffled,
    run: {
      ...drawn.run,
      hand: [...hand, ...drawn.drawn],
      deck: drawn.deck,
      discard: drawn.discard,
      rngState: drawn.rngState,
      energy: run.energy + 1,
      pendingChoice: null,
    },
  };
}
